import { message } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Card, Form, FormGroup, Input, Modal, ModalBody, Spinner } from "reactstrap";
import {
  Block,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  ManageRoleTable,
  PaginationComponent,
} from "../../../components/Component";
import { authHeader } from "../../../header";
import { useDebounce } from "../../../hooks/useDebounceSearch";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";

export const Managerole = () => {
  const [modal, setModal] = useState({
    edit: false,
    add: false,
    view: false,
  });
  const [editId, setEditedId] = useState();

  const [formData, setFormData] = useState({
    roleName: "",
    description: "",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage] = useState(7);
  const [manageRole, setManageRole] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadBtn, setIsLoadBtn] = useState(false);
  const [details, setDetails] = useState({});
  const [search, setSearch] = useState("");

  const onInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  const debouncedSearchTerm = useDebounce(search, 500);

  useEffect(
    () => {
      // if (debouncedSearchTerm) {
      getManageRole();
      setCurrentPage(1);
      // }v
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [debouncedSearchTerm] // Only call effect if debounced search term changes
  );

  const resetForm = () => {
    setFormData({
      roleName: "",
      description: "",
    });
  };

  const onFormCancel = () => {
    setModal({ edit: false, add: false });
    resetForm();
  };

  const getManageRole = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/auth/admin/role?search=${search}`, {
        headers: authHeader(),
      });
      const resultData = response.data;
      if (resultData) {
        setManageRole(resultData);
        setIsLoading(false);
      }
      return { formData };
    } catch (error) {
      setIsLoading(false);
    }
  };

  const [, setRights] = useState();
  const [productManageRights, setProductManageRights] = useState();
  const [userManageRights, setUserManageRights] = useState();
  const [processManageRights, setProcessManageRights] = useState();
  const [customerManageRights, setCustomerManageRights] = useState();
  const [reportRights, setReportRights] = useState();
  const [requestRights, setRequestRights] = useState();
  const [feedbackRights, setFeedbackRights] = useState();
  const [helpRights, setHelpRights] = useState();
  const [messageRights, setMessageRights] = useState();

  const getRights = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/auth/rights`, {
        headers: authHeader(),
      });
      const resultData = response.data;
      if (resultData) {
        setRights(resultData);
        setProductManageRights(resultData.filter((data) => data.moduleItem?.module?.name === "PRODUCT_MANAGEMENT"));
        setUserManageRights(resultData.filter((data) => data.moduleItem?.module?.name === "USER_MANAGEMENT"));
        setProcessManageRights(resultData.filter((data) => data.moduleItem?.module?.name === "PROCESS_MANAGEMENT"));
        setCustomerManageRights(resultData.filter((data) => data.moduleItem?.module?.name === "CUSTOMER_MANAGEMENT"));
        setReportRights(resultData.filter((data) => data.moduleItem?.module?.name === "REPORT"));
        setRequestRights(resultData.filter((data) => data.moduleItem?.module?.name === "REQUEST_CENTRE"));
        setFeedbackRights(resultData.filter((data) => data.moduleItem?.module?.name === "FEEDBACK"));
        setHelpRights(resultData.filter((data) => data.moduleItem?.module?.name === "HELP_CENTRE"));
        setMessageRights(resultData.filter((data) => data.moduleItem?.module?.name === "MESSAGE_CENTRE"));
      }
    } catch (error) {}
  };

  const formatText = (text) => {
    let formattedTxt = text.replace("_", " ");
    return formattedTxt;
  };

  const [selectedRights, setSelectedRights] = useState([]);
  const handleRightsSelect = (e) => {
    const { name, checked } = e.target;
    if (checked) {
      setSelectedRights([...selectedRights, name]);
    } else {
      let myrights = selectedRights;
      let index = selectedRights.indexOf(name);
      if (index > -1) {
        myrights.splice(index, 1);
        setSelectedRights(myrights);
      }
    }
  };

  const addManageRole = async (obj) => {
    const data = {
      roleName: obj.roleName,
      description: obj.description,
      rights: selectedRights,
    };
    try {
      setIsLoadBtn(true);
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/admin/role`, data, {
        headers: authHeader(),
      });
      const formData = await response.data;
      if (formData) {
        getManageRole();
        setSelectedRights([]);
        setIsLoadBtn(false);
        setIsLoading(false);
        message.success({
          content: "Role Created",
          style: {
            marginTop: "20vh",
          },
        });
      }
      setModal({ add: false });
      resetForm();
    } catch (error) {
      const message = error.response;
      setIsLoadBtn(false);
      setIsLoading(false);
      setModal({ add: false });
      message.error({
        content: message.data.message,
        style: {
          marginTop: "20vh",
        },
      });
      resetForm();
    } finally {
      setIsLoadBtn(false);
      setIsLoading(false);
      setModal({ add: false });
    }
  };

  const editManageRole = async (obj) => {
    try {
      setIsLoadBtn(true);
      const response = await axios.put(`${process.env.REACT_APP_BASE_URL}/admin/role/${editId}`, obj, {
        headers: authHeader(),
      });
      const formData = await response.data;
      if (formData) {
        getManageRole();
        message.success({
          content: "Role Updated Successfully!.",
          style: {
            marginTop: "20vh",
          },
        });
        setIsLoadBtn(false);
        setIsLoading(false);
        setModal({ edit: false });
        resetForm();
      }
    } catch (error) {
      const message = error.response;
      setIsLoadBtn(false);
      setIsLoading(false);
      setModal({ edit: false });
      message.error({
        content: message.data.message,
        style: {
          marginTop: "20vh",
        },
      });
      resetForm();
    } finally {
      setIsLoadBtn(false);
      setIsLoading(false);
      setModal({ edit: false });
    }
  };

  const onFormSubmit = () => {
    addManageRole({ ...formData, rights: selectedRights });
    resetForm();
    setModal({ add: false });
  };

  const onEditSubmit = () => {
    editManageRole({ ...formData, rights: selectedRights });
    resetForm();
    setModal({ edit: false });
  };

  const onEditClick = async (items) => {
    setModal({ edit: true });
    setFormData({
      roleName: items.roleName,
      description: items.description,
    });
    setSelectedRights(items?.assignedRights.map((right) => right.right));
    setDetails(items);
    setEditedId(items.id);
  };
  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = manageRole?.slice(indexOfFirstItem, indexOfLastItem);

  // Change Page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const { errors, register, handleSubmit } = useForm();

  useEffect(() => {
    getManageRole();
    getRights();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // const rightsOptions = rights?.map((right) => ({
  //   label: right.right,
  //   value: right.right,
  // }));

  return (
    <React.Fragment>
      <Head title="Role Management"></Head>
      <Content>
        <Block size="lg">
          <BlockHead>
            <BlockHeadContent>
              <div className="d-flex justify-content-between align-items-center">
                <BlockTitle tag="h4">Manage Role</BlockTitle>

                <div className="d-flex align-items-center justify-center">
                  <div className="mr-2">
                    <input
                      className="form-control"
                      value={search}
                      onChange={handleSearchChange}
                      placeholder="Search Role..."
                    />
                  </div>
                  <Button color="primary" onClick={() => setModal({ add: true })}>
                    <Icon name="plus" />
                    <span>Create Role</span>
                  </Button>
                </div>
              </div>
            </BlockHeadContent>
          </BlockHead>
          <Card className="card-bordered card-preview">
            {isLoading ? (
              <Spinner
                color="primary"
                style={{
                  height: "3rem",
                  width: "3rem",
                  margin: "0 auto",
                }}
              />
            ) : (
              <ManageRoleTable
                managerole={currentItems}
                modal={modal}
                onEditClick={onEditClick}
                onViewClick={(item) => {
                  setModal({ view: true });
                  setDetails(item);
                }}
              />
            )}
          </Card>
          <div className="card-inner">
            {manageRole && manageRole.length > 0 ? (
              <PaginationComponent
                itemPerPage={itemPerPage}
                totalItems={manageRole?.length}
                paginate={paginate}
                currentPage={currentPage}
              />
            ) : (
              <div className="text-center">
                <span className="text-silent">No role found</span>
              </div>
            )}
          </div>
        </Block>
        <Modal isOpen={modal.view} toggle={() => setModal({ add: false })} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm" />
            </a>
            <div className="p-2">
              <h5 className="title">View Role Details</h5>
              <div className="mt-4 p-4">
                <div className="d-flex justify-content-between  my-2">
                  <Col md="6">
                    <p className="p-0 m-0">
                      <span className="font-weight-bold">Role Name: </span>
                      <span>{details?.roleName}</span>
                    </p>
                  </Col>
                  <Col md="12">
                    <p className="p-0 m-0 ">
                      <span className="font-weight-bold">Description: </span>
                      <p style={{width: 300}}>{details?.description}</p>
                    </p>
                  </Col>
                </div>
                <div className="d-flex justify-content-between align-items-center my-2">
                  <Col md="12">
                    <p className="p-0 m-0">
                      <span className="font-weight-bold">Assigned Rights: </span>
                      <span>
                        {details?.assignedRights?.map((right) => (
                          <p>{right?.right}</p>
                        ))}
                      </span>
                    </p>
                  </Col>
                </div>

                <div className="d-flex justify-content-between align-items-center my-2">
                  <Col md="6">
                    <p className="p-0 m-0">
                      <span className="font-weight-bold">Date Created: </span>
                      <span>{details?.createdAt ?? "N/A"}</span>
                    </p>
                  </Col>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>
        <Modal isOpen={modal.add} toggle={() => setModal({ add: false })} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm" />
            </a>
            <div className="p-2">
              <h5 className="title">Add Role</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit(onFormSubmit)}>
                  <Col md="12">
                    <FormGroup>
                      <label className="form-label">Role</label>
                      <input
                        type="text"
                        name="roleName"
                        placeholder="Role"
                        onChange={(e) => onInputChange(e)}
                        className="form-control"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.roleName && <span className="invalid">{errors.roleName.message}</span>}
                    </FormGroup>
                  </Col>

                  {/*<Col md="6">
                    <FormGroup>
                      <label className="form-label">Rights</label>
                      <RSelect
                        options={rightsOptions}
                        isMulti
                        closeMenuOnSelect={false}
                        placeholder="Please Select Rights"
                        onChange={(e) => setFormData({ ...formData, rights: e })}
                      />
                    </FormGroup>
                  </Col>*/}
                  <Col size="12">
                    <FormGroup>
                      <label className="form-label">Description</label>
                      <textarea
                        name="description"
                        placeholder="Role description"
                        onChange={(e) => onInputChange(e)}
                        className="form-control-xl form-control no-resize"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.description && <span className="invalid">{errors.description.message}</span>}
                    </FormGroup>
                  </Col>

                  <Col md="12">
                    <h6 className="mt-5">Select Rights</h6>
                  </Col>
                  <Col md="12">
                    <p className="form-label">Product Management</p>
                  </Col>
                  {productManageRights?.map((right) => (
                    <Col key={right.id} md="4">
                      <FormGroup>
                        <Input
                          defaultChecked={selectedRights.includes(right.right)}
                          name={right.right}
                          type="checkbox"
                          onChange={(e) => handleRightsSelect(e)}
                        />
                        <label className="text-sm">{formatText(right.right)}</label>
                      </FormGroup>
                    </Col>
                  ))}

                  <Col md="12">
                    <p className="form-label">User Management</p>
                  </Col>
                  {userManageRights?.map((right) => (
                    <Col key={right.id} md="4">
                      <FormGroup>
                        <Input
                          defaultChecked={selectedRights.includes(right)}
                          name={right.right}
                          type="checkbox"
                          onChange={(e) => handleRightsSelect(e)}
                        />
                        <label className="text-sm">{formatText(right.right)}</label>
                      </FormGroup>
                    </Col>
                  ))}

                  <Col md="12">
                    <p className="form-label">Process Management</p>
                  </Col>
                  {processManageRights?.map((right) => (
                    <Col key={right.id} md="4">
                      <FormGroup>
                        <Input
                          defaultChecked={selectedRights.includes(right.right)}
                          name={right.right}
                          type="checkbox"
                          onChange={(e) => handleRightsSelect(e)}
                        />
                        <label className="text-sm">{formatText(right.right)}</label>
                      </FormGroup>
                    </Col>
                  ))}

                  <Col md="12">
                    <p className="form-label">Customer Management</p>
                  </Col>
                  {customerManageRights?.map((right) => (
                    <Col key={right.id} md="4">
                      <FormGroup>
                        <Input
                          defaultChecked={selectedRights.includes(right.right)}
                          name={right.right}
                          type="checkbox"
                          onChange={(e) => handleRightsSelect(e)}
                        />
                        <label className="text-sm">{formatText(right.right)}</label>
                      </FormGroup>
                    </Col>
                  ))}

                  <Col md="12">
                    <p className="form-label">Reports Center</p>
                  </Col>
                  {reportRights?.map((right) => (
                    <Col key={right.id} md="4">
                      <FormGroup>
                        <Input
                          defaultChecked={selectedRights.includes(right.right)}
                          name={right.right}
                          type="checkbox"
                          onChange={(e) => handleRightsSelect(e)}
                        />
                        <label className="text-sm">{formatText(right.right)}</label>
                      </FormGroup>
                    </Col>
                  ))}

                  <Col md="12">
                    <p className="form-label">Request Center</p>
                  </Col>
                  {requestRights?.map((right) => (
                    <Col key={right.id} md="4">
                      <FormGroup>
                        <Input
                          defaultChecked={selectedRights.includes(right.right)}
                          name={right.right}
                          type="checkbox"
                          onChange={(e) => handleRightsSelect(e)}
                        />
                        <label className="text-sm">{formatText(right.right)}</label>
                      </FormGroup>
                    </Col>
                  ))}

                  <Col md="12">
                    <p className="form-label">Message Center</p>
                  </Col>
                  {messageRights?.map((right) => (
                    <Col key={right.id} md="4">
                      <FormGroup>
                        <Input
                          defaultChecked={selectedRights.includes(right.right)}
                          name={right.right}
                          type="checkbox"
                          onChange={(e) => handleRightsSelect(e)}
                        />
                        <label className="text-sm">{formatText(right.right)}</label>
                      </FormGroup>
                    </Col>
                  ))}

                  <Col md="12">
                    <p className="form-label">Feedback Center</p>
                  </Col>
                  {feedbackRights?.map((right) => (
                    <Col key={right.id} md="4">
                      <FormGroup>
                        <Input
                          defaultChecked={selectedRights.includes(right.right)}
                          name={right.right}
                          type="checkbox"
                          onChange={(e) => handleRightsSelect(e)}
                        />
                        <label className="text-sm">{formatText(right.right)}</label>
                      </FormGroup>
                    </Col>
                  ))}

                  <Col md="12">
                    <p className="form-label">Help Center</p>
                  </Col>
                  {helpRights?.map((right) => (
                    <Col key={right.id} md="4">
                      <FormGroup>
                        <Input
                          defaultChecked={selectedRights.includes(right.right)}
                          name={right.right}
                          type="checkbox"
                          onChange={(e) => handleRightsSelect(e)}
                        />
                        <label className="text-sm">{formatText(right.right)}</label>
                      </FormGroup>
                    </Col>
                  ))}

                  <Col size="12">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <li>
                        <Button color="primary" size="md" type="submit">
                          {isLoadBtn ? <Spinner size="sm" /> : "Submit"}
                        </Button>
                      </li>
                      <li>
                        <Button
                          onClick={(ev) => {
                            ev.preventDefault();
                            onFormCancel();
                          }}
                          className="link link-light"
                        >
                          Cancel
                        </Button>
                      </li>
                    </ul>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>
        <Modal isOpen={modal.edit} toggle={() => setModal({ edit: false })} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm" />
            </a>
            <div className="p-2">
              <h5 className="title">Edit Role</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit(onEditSubmit)}>
                  <Col md="12">
                    <FormGroup>
                      <label className="form-label">Role</label>
                      <input
                        type="text"
                        name="roleName"
                        value={formData.roleName}
                        placeholder="Role"
                        onChange={(e) => onInputChange(e)}
                        className="form-control"
                      />
                    </FormGroup>
                  </Col>

                  <Col size="12">
                    <FormGroup>
                      <label className="form-label">Role Description</label>
                      <textarea
                        name="description"
                        value={formData.description}
                        placeholder="Role description"
                        onChange={(e) => onInputChange(e)}
                        className="form-control-xl form-control no-resize"
                      />
                    </FormGroup>
                  </Col>
                  <Col md="12">
                    <h6 className="mt-5">Select Rights</h6>
                  </Col>
                  <Col md="12">
                    <p className="form-label">Product Management</p>
                  </Col>
                  {productManageRights?.map((right) => (
                    <Col key={right.id} md="4">
                      <FormGroup>
                        <Input
                          defaultChecked={selectedRights.includes(right.right)}
                          name={right.right}
                          type="checkbox"
                          onChange={(e) => handleRightsSelect(e)}
                        />
                        <label className="text-sm">{formatText(right.right)}</label>
                      </FormGroup>
                    </Col>
                  ))}

                  <Col md="12">
                    <p className="form-label">User Management</p>
                  </Col>
                  {userManageRights?.map((right) => (
                    <Col key={right.id} md="4">
                      <FormGroup>
                        <Input
                          defaultChecked={selectedRights.includes(right.right)}
                          name={right.right}
                          type="checkbox"
                          onChange={(e) => handleRightsSelect(e)}
                        />
                        <label className="text-sm">{formatText(right.right)}</label>
                      </FormGroup>
                    </Col>
                  ))}

                  <Col md="12">
                    <p className="form-label">Process Management</p>
                  </Col>
                  {processManageRights?.map((right) => (
                    <Col key={right.id} md="4">
                      <FormGroup>
                        <Input
                          defaultChecked={selectedRights.includes(right.right)}
                          name={right.right}
                          type="checkbox"
                          onChange={(e) => handleRightsSelect(e)}
                        />
                        <label className="text-sm">{formatText(right.right)}</label>
                      </FormGroup>
                    </Col>
                  ))}

                  <Col md="12">
                    <p className="form-label">Customer Management</p>
                  </Col>
                  {customerManageRights?.map((right) => (
                    <Col key={right.id} md="4">
                      <FormGroup>
                        <Input
                          defaultChecked={selectedRights.includes(right.right)}
                          name={right.right}
                          type="checkbox"
                          onChange={(e) => handleRightsSelect(e)}
                        />
                        <label className="text-sm">{formatText(right.right)}</label>
                      </FormGroup>
                    </Col>
                  ))}

                  <Col md="12">
                    <p className="form-label">Report Center</p>
                  </Col>
                  {reportRights?.map((right) => (
                    <Col key={right.id} md="4">
                      <FormGroup>
                        <Input
                          defaultChecked={selectedRights.includes(right.right)}
                          name={right.right}
                          type="checkbox"
                          onChange={(e) => handleRightsSelect(e)}
                        />
                        <label className="text-sm">{formatText(right.right)}</label>
                      </FormGroup>
                    </Col>
                  ))}

                  <Col md="12">
                    <p className="form-label">Request Center</p>
                  </Col>
                  {requestRights?.map((right) => (
                    <Col key={right.id} md="4">
                      <FormGroup>
                        <Input
                          defaultChecked={selectedRights.includes(right.right)}
                          name={right.right}
                          type="checkbox"
                          onChange={(e) => handleRightsSelect(e)}
                        />
                        <label className="text-sm">{formatText(right.right)}</label>
                      </FormGroup>
                    </Col>
                  ))}

                  <Col md="12">
                    <p className="form-label">Message Center</p>
                  </Col>
                  {messageRights?.map((right) => (
                    <Col key={right.id} md="4">
                      <FormGroup>
                        <Input
                          defaultChecked={selectedRights.includes(right.right)}
                          name={right.right}
                          type="checkbox"
                          onChange={(e) => handleRightsSelect(e)}
                        />
                        <label className="text-sm">{formatText(right.right)}</label>
                      </FormGroup>
                    </Col>
                  ))}

                  <Col md="12">
                    <p className="form-label">Feedback Center</p>
                  </Col>
                  {feedbackRights?.map((right) => (
                    <Col key={right.id} md="4">
                      <FormGroup>
                        <Input
                          defaultChecked={selectedRights.includes(right.right)}
                          name={right.right}
                          type="checkbox"
                          onChange={(e) => handleRightsSelect(e)}
                        />
                        <label className="text-sm">{formatText(right.right)}</label>
                      </FormGroup>
                    </Col>
                  ))}

                  <Col md="12">
                    <p className="form-label">Help Center</p>
                  </Col>
                  {helpRights?.map((right) => (
                    <Col key={right.id} md="4">
                      <FormGroup>
                        <Input
                          defaultChecked={selectedRights.includes(right.right)}
                          name={right.right}
                          type="checkbox"
                          onChange={(e) => handleRightsSelect(e)}
                        />
                        <label className="text-sm">{formatText(right.right)}</label>
                      </FormGroup>
                    </Col>
                  ))}

                  <Col size="12">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <li>
                        <Button color="primary" size="md" type="submit">
                          {isLoadBtn ? <Spinner size="sm" /> : " Update"}
                        </Button>
                      </li>
                      <li>
                        <Button
                          onClick={(ev) => {
                            ev.preventDefault();
                            onFormCancel();
                          }}
                          className="link link-light"
                        >
                          Cancel
                        </Button>
                      </li>
                    </ul>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </Content>
    </React.Fragment>
  );
};
